import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://mkhtidnqlkamujwduubr.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1raHRpZG5xbGthbXVqd2R1dWJyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM4MjIzNTgsImV4cCI6MjA3OTM5ODM1OH0.QC9j5MncY4VMhykm_TNYdhO0J6ppcvfMpjoJGh_k9qQ";

const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;